<template>&nbsp;</template>
<script lang="ts" setup>
definePage({
  redirect: { name: '/account/profile/' },
})
</script>
